// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2LEfK","header":"MergedInvoice_header__3ijlD"};